module.exports = __webpack_public_path__ + "static/media/about.620baa08.jpg";